import { UseComboboxPropGetters } from '@synoptic/ui-kit/multi-select-combobox/multi-select-combobox.js';
import {
  multiSelectMenu,
  multiSelectMenuGroupTitle,
  multiSelectMenuItem,
  multiSelectMenuItemDisabled,
} from '@synoptic/ui-kit/multi-select-combobox/multi-select-group.css.ts';
import { Stream } from '@/__generated__/schema-types';
import { StreamListItem } from './stream-list-item';

export const TierStreamsSection = ({
  title,
  streams,
  tier1StreamIds,
  getItemProps,
  isItemDisabled,
}: {
  title: string;
  streams: Stream[];
  tier1StreamIds: ReadonlySet<string>;
  getItemProps: UseComboboxPropGetters<Stream>['getItemProps'];
  isItemDisabled: (stream: Stream) => boolean;
}) => (
  <div>
    <span className={multiSelectMenuGroupTitle}>{title}</span>
    <ul className={multiSelectMenu}>
      {streams.map((stream) => (
        <li
          key={stream.id}
          className={
            isItemDisabled(stream)
              ? multiSelectMenuItemDisabled
              : multiSelectMenuItem
          }
          {...getItemProps({ item: stream, id: stream.id })}
        >
          <StreamListItem
            stream={stream}
            inTier1={tier1StreamIds.has(stream.id)}
          />
        </li>
      ))}
    </ul>
  </div>
);
